import React, { useEffect } from "react"
import { Redirect, Route } from "react-router-dom"
import DefaultLayout from "app/components/Layout/DefaultLayout"
import { useDispatch, useSelector } from "react-redux"
import { changeModule } from "app/redux/moduleContext/moduleContext.actions"
import { authorize } from "app/redux/authorization/authorization.actions"
import { getPractice } from "app/redux/practice/practice.actions"
import { getShifts } from "app/redux/shifts/shifts.actions"
import * as practiceSelectors from "app/redux/practice/practice.selectors"
import * as authorizationSelectors from "app/redux/authorization/authorization.selectors"
import * as currentUserSelectors from "app/redux/currentUser/currentUser.selectors"
import LoadingScreen from "components/LoadingScreen"
import { useAccessRoles } from "app/components/AccessRoles"
import AppUtilityBar from "app/components/AppUtilityBar"
import { RouteObject } from "."

type TPrivateRouteProps = Omit<RouteObject, "isPrivate">
const PrivateRoute: React.FC<TPrivateRouteProps> = ({
  layout: CustomLayout,
  appUtilityBar: CustomUtilityBar,
  component,
  appBarComponent,
  module,
  allowedRoles,
  ...props
}) => {
  const dispatch = useDispatch()
  const practice = useSelector(practiceSelectors.getPractice)
  const hasUserAndToken = useSelector(currentUserSelectors.userAndTokenDispatched)
  const isAuthorizationInProgress = useSelector(authorizationSelectors.loading)
  const { isAllowed } = useAccessRoles(allowedRoles)

  const Layout = CustomLayout || DefaultLayout
  const UtilityBar = CustomUtilityBar || AppUtilityBar
  const isLoading = isAuthorizationInProgress || !hasUserAndToken || !practice

  const { path } = props

  useEffect(() => {
    dispatch(changeModule(module))
  }, [dispatch, module])

  useEffect(() => {
    dispatch(authorize())
  }, [dispatch])

  useEffect(() => {
    dispatch(getPractice())
  }, [dispatch])

  useEffect(() => {
    dispatch(getShifts())
  }, [dispatch])

  return (
    <Route
      {...props}
      key={path}
      render={matchProps => {
        if (isLoading) return <LoadingScreen />
        if (isAllowed)
          return (
            <Layout
              appUtilityBar={UtilityBar}
              component={component}
              appBarComponent={appBarComponent}
              module={module}
              matchProps={matchProps}
            />
          )
        return <Redirect to="/planning" />
      }}
    />
  )
}

export default PrivateRoute
